import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDevicePacketVisualizations',
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: null
    },
    parsedData: {
      type: [Object, String, Array],
      required: false,
      default: null
    },
    shouldShowParsedData: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      displayType: undefined
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language']),
    hasNoPacketData() {
      return this.data === null;
    }
  },
  watch: {
    shouldShowParsedData() {
      if (this.shouldShowParsedData) {
        this.displayType = 'parsed';
      }
    }
  },
  mounted() {
    if (this.shouldShowParsedData) {
      this.displayType = 'parsed';
    }
  },
  methods: {
    noop() {
      alert('no operation');
    }
  }
};